import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import { useAuth } from '../auth/hooks/useAuth';
import CartList from './components/CartList';
import { useCarts } from '../products/hooks/useCart';
import { useNavigate } from 'react-router-dom';
import NavbarBackComp from '../../shared/components/NavbarBack';
import Swal from 'sweetalert2';
import { GrCart } from 'react-icons/gr';
import { RxSlash } from 'react-icons/rx';

const CartPage = () => {

  const navigate = useNavigate();

  // const { validate, auth } = useAuth()
  const {
    editProductCart,
    fetchProductCartsById,
    fetchCartsByIdUser,
    removeCart,
    cart } = useCarts()

  const [cartItems, setCartItems] = useState()
  // const [cartItemsLoop, setCartItemsLoop] = useState([])
  const [selectedItems, setSelectedItems] = useState([]);

  // const [key, setKey] = useState("cart"); // Default tab is 'cart'

  // const [expandedOrders, setExpandedOrders] = useState({});

  // // Function to toggle expand/collapse state
  // const toggleExpand = (orderId) => {
  //   setExpandedOrders((prevState) => ({
  //     ...prevState,
  //     [orderId]: !prevState[orderId],
  //   }));
  // };

  // useEffect(() => {
  // }, [
  //   validate,
  //   fetchCartsByIdUser,
  // ]);

  const handleRemove = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await removeCart(id); // call your delete function
          Swal.fire('Deleted!', 'Your item has been deleted.', 'success');
          // Optionally refresh data or update state here
        } catch (error) {
          Swal.fire('Error!', 'There was a problem deleting your item.', 'error');
        }
      }
    });
  };

  // Handler to update the quantity of an item
  const handleUpdateQuantity = async (id, newQuantity) => {
    setCartItems((prevItems) =>
      (prevItems || []).map((item) =>
        item.id === id ? { ...item, qty: newQuantity } : item
      )
    );

    const updatedItem = cart.find((item) => item.id === id);

    await editProductCart(updatedItem?.id, {
      id: updatedItem?.id,
      qty: newQuantity,
      product: updatedItem?.product?.id
    });
    fetchCartsByIdUser();
  };

  const handleSelectItem = (id) => {
    setSelectedItems((prevSelectedItems) => {
      if (prevSelectedItems.includes(id)) {
        return prevSelectedItems.filter((itemId) => itemId !== id);
      } else {
        // Otherwise, select it
        return [...prevSelectedItems, id];
      }
    });
  };

  const calculateTotals = () => {
    let totalItems = 0;
    let totalPrice = 0;
    let totalHemat = 0;

    // Ensure cart is an array (convert if it's an object)
    const cartArray = Array.isArray(cart) ? cart : Object.values(cart || {});

    selectedItems.forEach((id) => {
      // Find the cart item with the matching id
      const item = cartArray.find((cartItem) => cartItem?.id === id);

      if (item) {
        totalItems += item.qty;
        totalPrice += item.qty * (item.product?.promo_price ? item.product?.promo_price : item.product?.starting_price) || 0
        // Calculate total savings
        if (item.product?.promo_price) {
          totalHemat += item?.qty * (item.product?.starting_price - item.product?.promo_price || 0);
        }
      }
    });

    return { totalItems, totalPrice, totalHemat };
  }

  const handleOrder = async () => {
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait while we process your transaction.',
      // allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    Swal.close();

    var cartData = [];

    for (const id of selectedItems) {
      const productData = await fetchProductCartsById(id); // Ensure we wait for each API call
      cartData.push(productData);
    }

    Swal.fire({
      title: 'Transaksi akan diproses! ingin melanjutkan?',
      text: 'Transaksi kamu akan segera diproses. Lanjutkan untuk pembayaran?',
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Lanjutkan!',
      cancelButtonText: 'Tidak, Tetap disini'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.close();
        navigate('/transaction', { state: { cartItems: cartData } });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        window.location.reload(); // Reload the page when "Tidak, Tetap disini" is clicked
      }
    });
  };
  const totals = useMemo(() => calculateTotals(), [cart, selectedItems]);

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <>
      <Container fluid style={{
        backgroundColor: '#f0f0f0',// Make sure the path is correct
        backgroundPosition: 'top right', // Position the image at the top-right corner
        backgroundSize: 'auto', // Adjust the size of the background image
        height: 'auto', // Make the container take full height (optional)
      }}>

        <Container className='md justify-content-center'>

          <NavbarBackComp
            expand="lg"
            sticky="top"
            handleBack={handleBack} />

          <span style={{
            fontSize: 12,
            color: 'gray'
          }}>RS YARSI</span>

          <p className='h6' style={{
            fontSize: 17,
            display: "flex",
            alignItems: "center",
            gap: "2px",
            padding: '0.1rem',
            paddingBottom: '2rem'
          }}>
            <span>Paket Layanan Kesehatan<RxSlash />Keranjang</span>
          </p>

          {/* <Card> */}
          <Row style={{
            borderTopLeftRadius: '2rem',
            borderTopRightRadius: '2rem',
            background: 'white'
          }}>

            <Col xs={12} md={12} style={{
              borderTopLeftRadius: '2rem',
              borderTopRightRadius: '2rem',
              paddingBottom: "20%",
              boxShadow: 'lg',
              background: 'white',
              margin: '0rem',
              marginLeft: '2rem',
              marginRight: '2rem',
              height: '88vh'
            }}>
              {/* <h2>Your Cart</h2> */}
              {cart?.length === 0 ? (
                <p>Keranjang kamu kosong ayo pilih paket sekarang.</p>
              ) : (
                <CartList
                  cartItems={Array.isArray(cart) ? cart : Object.values(cart || {})}
                  onRemove={handleRemove}
                  onUpdateQuantity={handleUpdateQuantity}
                  onSelectItem={handleSelectItem}
                />
              )}
            </Col>
          </Row>

          {/* 🛒 Fixed Checkout Bar at Bottom */}
          <div
            className="bg-white shadow p-2 w-100 w-md-50 w-xs-100 mx-auto"
            style={{
              position: "fixed",
              bottom: 0,
              left: "50%",
              // right: "50%",
              transform: "translateX(-50%)", // Centers the div horizontally
              // transform: "translateY(-50%)",
              width: "50%", // Default: full width for xs
              maxWidth: "50vw", // Limits width to 50% on md+,
              zIndex: 1050,
              // paddingBottom: '0.1rem'
              // borderTop: "1px solid #ddd"
            }}
          >
            <Row className="">
              {/* Left Side: Total Items & Price */}
              {/* <Col xs={3} sm={6} md={3} className="text-center text-sm-start mb-2 mb-xs-5 mb-md-0">
                    <div>
                      Items: {totals.totalItems}
                    </div>
                    <div>
                      <strong>Total Price:</strong> Rp {totals.totalPrice}
                    </div>
                  </Col> */}

              {/* Middle: Discount / Savings */}
              <Col xs={12} sm={6} md={6}>
                {/* <Row className="text-center text-sm-start">
                  <Col xs={12} sm={6} md={2}><span>{totals.totalItems} Qty</span></Col>
                  <Col xs={12} sm={6} md={4} style={{ gap: '0.1rem' }}>
                    <p style={{ gap: '0.1rem' }}>Rp. {totals.totalPrice}</p>
                  </Col>
                  <Col xs={12} sm={6} md={6}>
                    {totals.totalHemat ? (
                      <p style={{ display: "flex", alignItems: "center", gap: "0.1rem" }}>
                        Potongan Rp{" "}
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          {totals.totalHemat}
                        </span>
                      </p>
                    ) : null}
                    <p>{totals.totalItems} Qty</p>
                  </Col>
                </Row> */}
                <div>
                  {totals.totalHemat ? <>
                    <p>Potongan Rp
                      <span style={{ color: "green", fontWeight: "bold", gap: "0rem" }}>
                        {totals.totalHemat}
                      </span>
                      <br />
                      <span style={{ color: "grey", fontWeight: "bold", gap: "0rem" }}>
                        {totals.totalItems} Qty
                      </span>
                    </p>
                  </> : <>
                    <p>
                      <span style={{ color: "grey", fontWeight: "bold", gap: "0rem" }}>
                        {totals.totalItems} Qty
                      </span>
                    </p>
                  </>}
                </div>
              </Col>

              {/* Right Side: Checkout Button */}
              <Col xs={12} sm={6} md={6} className="text-md-end">
                <Button
                  variant="danger"
                  size="lg"
                  style={{
                    borderRadius: "5px",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "1px",
                    gap: "0.1rem", // Adjust spacing between <p> elements
                    fontSize: '12px',
                    padding: '0.5rem'
                  }}
                  disabled={selectedItems.length === 0}
                  onClick={handleOrder}
                >
                  <p className="mb-2">Rp. {totals.totalPrice}</p>
                  <p className="mb-0">Lanjutkan Pembayaran</p>
                </Button>
              </Col>
            </Row>
          </div>
          {/* </Card> */}

        </Container>

        {/* <Container>
              <ListGroup className="fixed-bottom bg-white shadow p-3"
                style={{
                  // borderTop: "1px solid #ddd",
                  justifyContent: "space-between",
                }}>
                <ListGroup.Item>
                  Total Items: {totals.totalItems}
                </ListGroup.Item>
                <ListGroup.Item>
                  Total Price: Rp. {totals.totalPrice.toFixed(2)}
                </ListGroup.Item>
                <ListGroup.Item>
                  <Button
                    variant="success"
                    style={{ borderRadius: 0 }}
                    disabled={selectedItems.length === 0}
                    onClick={handleOrder}
                  >
                    Proceed to Checkout
                  </Button>
                </ListGroup.Item>
              </ListGroup>
            </Container> */}

      </Container>

    </>
  );
};

export default CartPage;
